export default function UseGetUserVerificatorDataTwo(data) {
    const userBusiness = data?.empleadores?.map((el) => {
        return {
            bp: parseInt(el.bp),
            id: parseInt(el.empleadorNumeroDocumento),
            idType: el.empleadorTipoDocumento,
            businessName: el.empleadorRazonSocial,
            status: el.empleadorEstado,
            mainBusiness: el.titularEmpresaPrincipal,
            group: el.agrupacion,
            location: el.sucursal,
            bussinesAdmissionDate: el.titularFechaIngresoEmpresa,
            bussinesExpirationDate: el.titularFechaFinVigencia,
            bussinesEffectiveStartDate: el.titularFechaInicioVigencia,
        };
    });

    const userBeneficiaries = data.pacs.map((el) => {
        return {
            bp: parseInt(el.bp),
            id: parseInt(el.pacnumeroDocumento),
            idType: el.pactipoDocumento,
            fullName: `${el.pacprimerNombre} ${el.pacsegundoNombre} ${el.pacprimerApellido} ${el.pacsegundoApellido}`,
            age: parseInt(el.pacedad),
            gender: el.pacgenero,
            relationship: el.parentesco,
            relationshipDescription: el.descripcionParentesco,
            birthDate: el.pacfechaNacimiento,
            comfamaDate: el.pacfechaInicioVigencia,
            expirationDate: el.pacfechaFinVigencia,
            fee: el.pacvalorSubsidio,
            salarialCategory: el.paccategoriaSalarial,
        };
    });

    return {
        bp: parseInt(data.bp),
        id: parseInt(data.titularNumeroDocumento),
        idType: data.titularTipoDocumento,
        fullName: `${data.titularPrimerNombre || ''} ${
            data.titularSegundoNombre || ''
        } ${data.titularPrimerApellido || ''} ${
            data.titularSegundoApellido || ''
        }`,
        birthDate: data.titularFechaNacimiento,
        age: parseInt(data.titularEdad),
        gender: data.titularGenero,
        salarialCategory: data.titularCategoriaSalarial,
        afiliatedGroup: data.titularGrupoAfiliado,
        monetaryFeeValue: data.valorCuotaMonetaria,
        status: data.titularEstado,
        statusCause: data.titularEstadoMotivo,
        fee: data.tarifa,
        simultaneousCompanies: data.titularEmpresasSimultaneas,
        companyAdmissionDate: data.titularFechaIngresoEmpresa,
        expirationDate: data.titularFechaFinVigencia,
        effectiveStartDate: data.titularFechaInicioVigencia,
        contributionPercentaje: data.cargo,
        salaryType: data.titularTipoSalario,
        cardNumber: parseInt(data.titularNumeroTarjeta),
        cardStatus: data.titularEstadoTarjeta,
        cardLot: parseInt(data.titularLoteTarjeta),
        civilStatus: parseInt(data.titularEstadoCivil),
        businessList: userBusiness,
        beneficiaries: userBeneficiaries,
    };
}
